import { forwardRef, type KeyboardEvent } from 'react'

interface StickyNoteEditorProps {
  fontSize: number
  text: string
  onChange: (v: string) => void
  onSave: () => void
  onClose: () => void
  onKeyDown: (e: KeyboardEvent<HTMLTextAreaElement>) => void
}

const StickyNoteEditor = forwardRef<HTMLTextAreaElement, StickyNoteEditorProps>(function StickyNoteEditor(
  { fontSize, text, onChange, onSave, onClose, onKeyDown },
  ref
) {
  return (
    <div className="absolute inset-0 flex flex-col p-3 z-10 bg-inherit rounded-lg nowheel" onWheelCapture={(e) => e.stopPropagation()}>
      <div className="flex justify-between items-center mb-2">
        <span className="text-xs font-semibold opacity-70">Editar Nota</span>
        <div className="flex gap-1">
          <button
            onClick={onSave}
            className="px-2 py-1 text-xs rounded hover:bg-black/10 transition-colors"
            title="Guardar"
          >
            Guardar
          </button>
          <button
            onClick={onClose}
            className="px-2 py-1 text-xs rounded hover:bg-black/10 transition-colors"
            title="Cerrar"
          >
            ✕
          </button>
        </div>
      </div>

      <textarea
        ref={ref}
        value={text}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        className="flex-1 w-full resize-none bg-transparent border-none outline-none p-1 font-mono"
        style={{ fontSize: `${fontSize}px` }}
        placeholder="Escribe aquí... (markdown soportado)"
        name="sticky-note-content"
        aria-label="Contenido de la nota adhesiva"
        onWheelCapture={(e) => e.stopPropagation()}
      />

      <div className="text-[10px] opacity-50 mt-1">
        Tab: indentar • Shift+Tab: desindentar
      </div>
    </div>
  )
})

export default StickyNoteEditor
